import { render } from "./productSettingsView.vue?vue&type=template&id=3331dcbc&scoped=true"
import script from "./productSettingsView.vue?vue&type=script&lang=js"
export * from "./productSettingsView.vue?vue&type=script&lang=js"

import "./productSettingsView.vue?vue&type=style&index=0&id=3331dcbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3331dcbc"]])

export default __exports__